/* The preview toolbar belongs to Shopify; reserve space only in this draft. */
(() => {
  'use strict';
  const shopify = window.Shopify || {};
  const theme = shopify.theme || {};
  if (String(theme.id) !== '131194126394') return;
  if (theme.role !== 'unpublished' && shopify.previewMode !== true && shopify.designMode !== true) return;
  if (!document.body || document.getElementById('pc-draft-toolbar-clearance')) return;
  const clearance = document.createElement('div');
  clearance.id = 'pc-draft-toolbar-clearance';
  clearance.setAttribute('aria-hidden', 'true');
  clearance.style.cssText = 'height:calc(96px + env(safe-area-inset-bottom, 0px));min-height:96px;flex-shrink:0;pointer-events:none;';
  document.body.append(clearance);
})();
